// extracted by mini-css-extract-plugin
export default {"container":"_34f8A","description":"_2tL6U","checkboxContainer":"_3ZAsB","alert":"_1HRMg","policy":"_1So6Q","sectionNotificationContainer":"_2hT2o","labelContainer":"_3yE6d"};